var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "content-hub-generic bg-white p-4" },
    [
      _c("ci-breadcrumbs", { attrs: { items: _vm.breadCrumbs } }),
      _c("h1", {
        staticClass: "h4 text-capitalize m-0 mt-3",
        domProps: { textContent: _vm._s(_vm.lastTag) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }